export default "__VITE_ASSET__4Uenimh8__"